import { useRef } from "react";
import { Box } from "@mui/material";
import dynamic from "next/dynamic";
import { IPortfolioTableDict } from "src/api/server/wf-detail.types";
import { IPortfolioDataTableProps } from "src/components-mui/pages/detail/portfolio-table-section/portfolio-data-table";
import { PortfolioTableErrorState } from "src/components-mui/pages/detail/portfolio-table-section/portfolio-table-error-state";
import { PortfolioTableSkeleton } from "src/components-mui/pages/detail/portfolio-table-section/portfolio-table-skeleton";
import { usePortfolioTable } from "src/components-mui/pages/detail/portfolio-table-section/use-portfolio-table";

const PortfolioDataTable = dynamic<IPortfolioDataTableProps>(
    () => import("src/components-mui/pages/detail/portfolio-table-section/portfolio-data-table").then(component => component.PortfolioDataTable),
    { loading: () => <PortfolioTableSkeleton isAnimated /> }
);

interface IPortfolioTableProps {
    fullName: string;
    dict: IPortfolioTableDict;
}

export const PortfolioTable = ({ fullName, dict }: IPortfolioTableProps) => {
    const sectionRef = useRef<HTMLDivElement>(null);

    const { isLoading, isError, data, sorting, onSort } = usePortfolioTable(fullName, sectionRef);

    return (
        <Box ref={sectionRef} aria-live="polite" aria-busy={isLoading}>
            {isError && (
                <PortfolioTableErrorState>
                    <PortfolioTableSkeleton isAnimated={false} />
                </PortfolioTableErrorState>
            )}
            {!isError && !data && <PortfolioTableSkeleton isAnimated={isLoading} />}
            {data && <PortfolioDataTable dict={dict} data={data} sorting={sorting} onSort={onSort} />}
        </Box>
    );
};
